import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pay',
  templateUrl: './pay.component.html',
  styleUrls: ['./pay.component.scss']
})
export class PayComponent implements OnInit {

  registrationInfo = {
    captain_name: "",
    company_name: "",
    address: {
      address1: "",
      city: "",
      state: "",
      zip: ""
    },
    email: "",
    player1: {
      name: "",
      size: ""
    },
    player2: {
      name: "",
      size: ""
    },
    player3: {
      name: "",
      size: ""
    },
    player4: {
      name: "",
      size: ""
    }

  }

  constructor() { }

  ngOnInit() {
  }

  submit(){

  }

}



// WEBPACK FOOTER //
// ./src/app/pay/pay.component.ts